import * as R from 'ramda'
import { useEffect, useMemo } from 'react'
import { Store } from 'redux'
import { initialState } from 'src/store/initial'
import initStore, { reduxStore } from 'src/store'

export default function useStore(initialProps: object) {
  const store = useMemo(() => {
    return initStore(R.mergeDeepLeft(initialProps, initialState))
  }, [initialProps])

  useEffect(() => {
    ;(reduxStore as Store | null)?.dispatch({
      type: 'REPLACE_STATE',
      data: initialProps
    })
  }, [initialProps])

  return store
}
